// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SYSTEM_TEMPLATE_MODAL_CHANGE,
} from './constants';

export function templateModalChange(visible,values) {
  return {
    type: SYSTEM_TEMPLATE_MODAL_CHANGE,
    data: {visible,values}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_TEMPLATE_MODAL_CHANGE:
    console.log('action----------------'+action.data.visible)
    console.log('action----------------'+action.data.values)
      return {
        ...state,
        tagssModalVisible:action.data.visible,
        addTagModalType:action.data.values,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/templateModalChange.js